import { WorksProvider } from 'components/works/context';
import { WorksFilter } from 'components/works/filter';
import { WorkList } from 'components/works/list';
import { WorksPagination } from 'components/works/pagination';
import { PickupWorks } from 'components/works/pickup';
import React from 'react';
import styles from './WorksPage.module.scss';

const WorkPage: React.FC = () => (
  <div className={styles.page}>
    <main className={styles.basic}>
      <WorksProvider>
        <PickupWorks />
        <WorksFilter />
        <WorkList />
        <WorksPagination />
      </WorksProvider>
    </main>
  </div>
);

export default WorkPage;
